import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Lock(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M8 7.444C8 5.651 9.678 4 12 4s4 1.65 4 3.444V10H8V7.444zM6 10V7.444C6 4.331 8.802 2 12 2s6 2.331 6 5.444V10h.222C19.773 10 21 11.287 21 12.818v6.364C21 20.712 19.773 22 18.222 22H5.778C4.227 22 3 20.713 3 19.182v-6.364C3 11.288 4.227 10 5.778 10H6zm11 2H5.778c-.405 0-.778.35-.778.818v6.364c0 .469.373.818.778.818h12.444c.405 0 .778-.35.778-.818v-6.364c0-.469-.373-.818-.778-.818H17z",
    clipRule: "evenodd"
  }));
}

export default Lock;